import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi } from '../services/agents-api.service';

const useUserIsMindyAdmin = () => {
    const queryClient = useQueryClient();
    const userIsMindyAdmin = useMutation({
        mutationFn: (userId: string) => agentsApi.userIsMindyAdminChange(userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['document-permissions'] });
        },
        onError: (error) => {
            console.error('Error in userIsMindyAdminChange:', error);
        },
    });
    return {
        userIsMindyAdmin,
    };
};

export default useUserIsMindyAdmin;
